/*供应商 */
import { $http, buildHeaders } from "./index";

//#region 基本信息

//获取列表
export const supplier_page = (params) => {
  return $http.get("/admin/Supplier/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const supplier_detail = (id) => {
  return $http.get("/admin/Supplier/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const supplier_add = (data) => {
  return $http.post("/admin/Supplier/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const supplier_edit = (data) => {
  return $http.post("/admin/Supplier/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改状态
export const supplier_updateStatus = (data) => {
  return $http.post("/admin/Supplier/updateStatus", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const supplier_delete = (id) => {
  return $http.post(
    "/admin/Supplier/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 联系人

//获取列表
export const supplier_contact_page = (params) => {
  return $http.get("/admin/SupplierContact/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const supplier_contact_detail = (id) => {
  return $http.get("/admin/SupplierContact/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const supplier_contact_add = (data) => {
  return $http.post("/admin/SupplierContact/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const supplier_contact_edit = (data) => {
  return $http.post("/admin/SupplierContact/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const supplier_contact_delete = (id) => {
  return $http.post(
    "/admin/SupplierContact/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 常用明细项

//获取列表
export const supplier_costitem_page = (params) => {
  return $http.get("/admin/SupplierCostItem/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//删除
export const supplier_costitem_delete = (id) => {
  return $http.post(
    "/admin/SupplierCostItem/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 银行账户

//获取列表
export const supplier_bank_account_page = (params) => {
  return $http.get("/admin/SupplierBankAccount/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const supplier_bank_account_detail = (id) => {
  return $http.get("/admin/SupplierBankAccount/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const supplier_bank_account_add = (data) => {
  return $http.post("/admin/SupplierBankAccount/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const supplier_bank_account_edit = (data) => {
  return $http.post("/admin/SupplierBankAccount/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改状态
export const supplier_bank_account_updateStatus = (data) => {
  return $http.post("/admin/SupplierBankAccount/updateStatus", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const supplier_bank_account_delete = (id) => {
  return $http.post(
    "/admin/SupplierBankAccount/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 预付管理

//获取列表
export const supplier_payment_apply_page = (params) => {
  return $http.get("/admin/SupplierPaymentApply/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const supplier_payment_apply_detail = (id) => {
  return $http.get("/admin/SupplierPaymentApply/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const supplier_payment_apply_search = (id) => {
  return $http.get("/admin/SupplierPaymentApply/detail?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const supplier_payment_apply_add = (data) => {
  return $http.post("/admin/SupplierPaymentApply/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const supplier_payment_apply_edit = (data) => {
  return $http.post("/admin/SupplierPaymentApply/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const supplier_payment_apply_delete = (id) => {
  return $http.post(
    "/admin/SupplierPaymentApply/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 采购管理

//获取列表
export const supplier_purchase_page = (params) => {
  return $http.get("/admin/SupplierPurchase/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const supplier_purchase_detail = (id) => {
  return $http.get("/admin/SupplierPurchase/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};


//获取详情
export const supplier_purchase_search = (id) => {
  return $http.get("/admin/SupplierPurchase/detail?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};


//获取采购申请付款数据
export const supplier_purchase_applyPayment = (params) => {
  return $http.get(
    "/admin/SupplierPurchase/applyPayment",
    {
      params,
    },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//提交申请付款
export const supplier_purchase_applyPaymentSubmit = (data) => {
  return $http.post("/admin/SupplierPurchase/applyPaymentSubmit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//获取预付冲销数据
export const supplier_purchase_paymentTrade = (params) => {
  return $http.get(
    "/admin/SupplierPurchase/paymentTrade",
    { params },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//提交预付冲销
export const supplier_purchase_paymentTradeSubmit = (data) => {
  return $http.post("/admin/SupplierPurchase/paymentTradeSubmit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 采购付款申请

//获取采购付款申请记录列表
export const supplier_purchase_payment_apply_page = (params) => {
  return $http.get("/admin/SupplierPurchasePaymentApply/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取采购付款申请记录详情
export const supplier_purchase_payment_apply_detail = (id) => {
  return $http.get("/admin/SupplierPurchasePaymentApply/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//取消申请付款
export const supplier_purchase_payment_apply_cancel = (data) => {
  return $http.post("/admin/SupplierPurchasePaymentApply/cancel", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 附件

//获取列表
export const supplier_attachment_page = (params) => {
  return $http.get("/admin/SupplierAttachment/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const supplier_attachment_add = (data) => {
  return $http.post("/admin/SupplierAttachment/add", data, {
    headers: buildHeaders(2, "正在提交数据，请稍后……"),
  });
};

//删除
export const supplier_attachment_delete = (id) => {
  return $http.post(
    "/admin/SupplierAttachment/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion
